import React, { Component } from "react"
import PropTypes from "prop-types"
import queryString from "query-string"
import SbEditable from "storyblok-react"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import Button from "../button"

import storyblokLinkHandler from "../../helpers/storyblokLinkHandler"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import SbImageService from "../../helpers/SbImageService"
import EventsConfig from "../../helpers/eventsConfig"

const postscribe = typeof window !== "undefined" ? require("postscribe") : null

class HeroEvent extends Component {
  state = {
    contactId: "",
  }

  componentDidMount() {
    const { title, googleEventStartTime, googleEventEndTime } = this.props.blok

    if (title && googleEventStartTime && googleEventEndTime) {
      this.googleEvent()
    }
    if (window) {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S

      this.setState({ contactId: contactId })
    }
  }

  googleEvent = () => {
    const {
      title,
      post_zip,
      address_line_1,
      address_line_2,
      address_line_3,
      calendly_url,
      image,
      googleEventStartTime,
      googleEventEndTime,
      description,
    } = this.props.blok

    const location = post_zip
      ? `"@type": "Place",
        "name": ${address_line_1 ? `"${address_line_1}"` : `""`},
        "address": {
          "@type": "PostalAddress",
          "streetAddress": ${address_line_2 ? `"${address_line_2}"` : `""`},
          "addressLocality": ${address_line_3 ? `"${address_line_3}"` : `""`},
          "postalCode": ${post_zip ? `"${post_zip}"` : `""`}
          }`
      : `"@type": "VirtualLocation",
      "url": "${calendly_url}"`

    postscribe(
      document.head,
      `
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "Event",
      "name": ${title ? `"${title}"` : `""`},
      "startDate": "${this.dateTimeFormater(googleEventStartTime)}",
      "endDate": "${this.dateTimeFormater(googleEventEndTime)}",
      "eventAttendanceMode": "https://schema.org/${
        post_zip ? "OfflineEventAttendanceMode" : "OnlineEventAttendanceMode"
      }",
      "eventStatus": "https://schema.org/EventScheduled",
      "location": {
        ${location}
      },
      "image": [
        ${image ? `"https:${this.props.blok.image}"` : `""`}
       ],
      "description": ${description ? `"${description}"` : `""`},
      "offers": {
      },
      "performer": {
      },
      "organizer": {
        "@type": "Organization",
        "name": "Hult International Business School",
        "url": "https://www.hult.edu"
      }
    }
    </script>`
    )
  }

  dateTimeFormater = (dateTime) => new Date(dateTime).toISOString()

  render = () => {
    const { blok } = this.props
    const { calendlyWidgetPath } = this.props.eventsConfig
    const hrefUrl = storyblokLinkHandler(blok.calendly_url)

    return (
      <SbEditable content={blok}>
        <div className="hero-event">
          <div className="hero-event__container container container--md-pd-none">
            <div className="hero-event__intro card card--pd-md">
              <h1 className="hero-event__title heading heading--accent">
                {blok.title}
              </h1>
              <div className="hero-event__description">
                {
                  unified()
                    .use(remarkParse)
                    .use(remarkRehype)
                    .use(rehypeReact, {
                      createElement: React.createElement,
                      components: remarkReactComponents,
                      Fragment: React.Fragment,
                    })
                    .processSync(blok.description).result
                }
              </div>
              <address className="hero-event__address">
                <p>
                  {blok.address_line_1 && (
                    <>
                      {blok.address_line_1}
                      <br />
                    </>
                  )}
                  {blok.address_line_2 && (
                    <>
                      {blok.address_line_2}
                      <br />
                    </>
                  )}
                  {blok.address_line_3 && (
                    <>
                      {blok.address_line_3}
                      <br />
                    </>
                  )}
                  {blok.city && (
                    <>
                      {blok.city}
                      <br />
                    </>
                  )}
                  {blok.post_zip}
                  {blok.map_url && (
                    <>
                      <br />
                      <a
                        className="hero-event__a"
                        target="_blank"
                        rel="noopener noreferrer"
                        href={blok.map_url}
                      >
                        {blok.map_text}
                      </a>
                    </>
                  )}
                </p>
              </address>
              {blok.calendly_url && (
                <a
                  href={
                    blok.calendly_url.includes("https://calendly.com")
                      ? `${storyblokLinkHandler(
                          calendlyWidgetPath
                        )}?calendly=${encodeURIComponent(blok.calendly_url)}${
                          this.state.contactId
                            ? "&S=" + this.state.contactId
                            : ""
                        }`
                      : hrefUrl
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hero-event__action-container"
                >
                  <div className="hero-event__action">
                    <div>
                      <p className="hero-event__action-copy">{blok.date}</p>
                    </div>
                    <div className="hero-event__action-btn-container">
                      <Button
                        className="hero-event__action-btn"
                        iconName={blok.button_icon}
                        text={blok.button_text}
                      />
                    </div>
                  </div>
                </a>
              )}
            </div>
            {blok.image && (
              <div
                className="hero-event__image"
                style={{
                  backgroundImage: `url("${SbImageService(blok.image)}")`,
                }}
              ></div>
            )}
          </div>
        </div>
      </SbEditable>
    )
  }
}

HeroEvent.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    address_line_1: PropTypes.string,
    address_line_2: PropTypes.string,
    address_line_3: PropTypes.string,
    city: PropTypes.string,
    post_zip: PropTypes.string,
    map_url: PropTypes.string,
    map_text: PropTypes.string,
    date: PropTypes.string,
    image: PropTypes.string,
    calendly_url: PropTypes.string,
    button_icon: PropTypes.string,
    button_text: PropTypes.string,
  }).isRequired,
}

export default EventsConfig(HeroEvent)
